import { render, staticRenderFns } from "./SkillsLibrary.vue?vue&type=template&id=9946a32a&"
import script from "./SkillsLibrary.vue?vue&type=script&lang=js&"
export * from "./SkillsLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports